const modelDetails = [{
  key: 'textures',
  label: 'Textures',
}, {
  key: 'materials',
  label: 'Materials',
}, {
  key: 'uvwMapping',
  label: 'UV Mapping',
}, {
  key: 'pluginsUsed',
  label: 'Plugins used',
}]

export default modelDetails
